import { View } from '@gluestack-ui/themed'
import React, { FunctionComponent } from 'react'
import { StyleSheet, TouchableWithoutFeedback, TouchableWithoutFeedbackProps } from 'react-native'
import { ViewProps } from '../../../redux/theme/types'
import { theme } from '../../../theme'

export const ListItem: FunctionComponent<TouchableWithoutFeedbackProps & ViewProps> = ({ onPress, style, ...props }) => (
  <TouchableWithoutFeedback onPress={onPress}>
    <View style={[styles.touchable, style]} {...props} />
  </TouchableWithoutFeedback>
)

const styles = StyleSheet.create({
  touchable: {
    flex: 1,
    flexDirection: 'row',
    paddingHorizontal: theme.padding.x4,
    paddingVertical: theme.padding.x2,
  },
})
